import React from "react";
import { Header } from '../../Components/Layout/Header.jsx';
import { MetaTags } from '../../Components/Layout/MetaTags.jsx';
import { GameDetails } from '../../Components/Game/GameDetails.jsx';
import { ObavijestiCasino } from '../../Components/Layout/ObavijestiCasino.jsx';
import { Game } from '../../Components/Game/Game.jsx';

export class EgyptQuest extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            igre: null, 
            categories:null,
            tabs: ['Informacije', 'Egypt Quest igre'] }
        this.setData = this.setData.bind(this);
        this.dohvatiIgrePremaKategoriji = this.dohvatiIgrePremaKategoriji.bind(this);
        this.renderIgra = this.renderIgra.bind(this);

        this.gameContainer = React.createRef();
    }

    componentDidMount() {
        this.gotoTab(this.state.tabs[0]);

        window.scrollTo(0, 0);

        this.props.showMenuFn(false);
        this.props.showLoadingFn(true);

        var promises = Promise.all([casino.repos.gameRepo.list().then(this.props.unpackGamesListFn), casino.repos.categoryRepo.list().then(this.props.saveCategoriesFn)]);

        this.dataPromises = casino.utils.makeCancelablePromise(promises);
        this.dataPromises.promise.then(this.setData, function (reason) { });
    }

    componentWillUnmount() {
        this.dataPromises.cancel();
        this.props.showLoadingFn(false);
    }    

    gotoTab(tab) {
        if (tab === "Egypt Quest igre") {
            setTimeout(() => casino.utils.lazyImages.mountEventLazyLoadImages(), 0);
        }
        this.setState({ selectedTab: tab });
    }

    getBody() {
        if (this.state.selectedTab === 'Egypt Quest igre') {
               return <div id="game-container" className="maximum margin-center" ref={this.gameContainer}>    
                    <br></br>
                    <div className={"clearfix white games-container"} style={(this.state.igre && this.state.selectedCategoryId == -1) ? { padding: '0px' } : {}} >
                        {!this.state.igre && <div>Dohvaćanje igara...</div>}
                        {this.state.igre && this.dohvatiIgrePremaKategoriji().map(this.renderIgra)}
                    </div>
                </div>
        } else if (this.state.selectedTab === 'Informacije') {
               return <div>
                    <p className="description">
                    Kada u "egypt quest" igri osvojiš tri egypt quest scatera dobivaš 8 jackpot spinova! </p>
                    <div className="img-info-container">
                        <span>
                            <img src="content/images/egyptquest/how_to_image_A.png"  className="responsive"/>
                            <div>Osvojen Platinasti nivo jackpota.</div>
                        </span>
                        <span>
                            <img src="content/images/egyptquest/how_to_image_B.png"  className="responsive"/>
                            <div>Osvojeni jackpot spinovi.</div>
                        </span>
                    </div>
                    <p  className="description">Odvrti ih i <strong>pokupi dobitke!</strong> </p>
                    <p  className="description">Ali to nije sve :-)</p>
                    <p  className="description">Kada u free jackpot spinovima nadmašiš brončani nivo osvajaš dobitke i Brončani jackpot.</p>
                    <p  className="description">Kada u free jackpot spinovima nadmašiš srebrni nivo osvajaš dobitke spinova i Srebrni jackpot.</p>
                    <p  className="description">Već vidiš kamo to ide...</p>
                    <p  className="description"><strong>Zaigraj i osvoji Platinasti jackpot.</strong></p>
                </div>
        }
    }

    setData(data) {
        var [igre, kategorije] = data;
        this.setState({
            igre: igre,
            categories: kategorije.items,
        });

        this.props.showLoadingFn(false);
    }

    dohvatiIgrePremaKategoriji() {
        //19 - id kategorije 'EgyptQuest'
        return this.state.igre.filter(x => Object.keys(x.kt).includes("19"));
    }

    renderIgra(igra, i) {
        return <Game brands={this.props.brands} categories={this.state.categories} routePrefix={"/egypt-quest"} ref={"game-" + igra.id} key={igra.sifra} igra={igra} showJackpot={true} goLazyImage={true} />;
    }

    render() {
       return  <div>
            <MetaTags title="Egypt Quest - SuperSport CASINO" description={"Zaigraj Egypt Quest u SuperSport CASINU!"} />
            <Header key="header" {...this.state} {...this.props} disableBrowserBack={true}></Header>
            
            <div className="egypt-quest-banner">
                {/* <div className="small-title">Veliki JACKPOT svaki dan!</div> */}
                {/* <div className="big-title">EGYPT QUEST</div> */}
            </div>
            <div id="page-wrapper" className="no-padding grey">
                <div className="egypt-quest-info-container maximum margin-center" >
                    <div className="title">Egypt Quest</div>
                    <p className="subtitle">
                        Igraj igrice s oznakom "egypt quest" i osvoji Brončani, Srebrni, Zlatni ili Platinasti jackpot!  

                    </p>
                    <div>
                        <div className="segment v2">
                        {this.state.tabs && this.state.tabs.map((tab) =>
                            <button key={tab} onClick={() => this.gotoTab(tab)} className={'segment--btn' + (this.state.selectedTab === tab ? ' selected' : '')}><span>{tab}</span></button>
                        )}
                        </div>
                        {this.getBody()}
                    </div>
                </div>
            </div>

            <GameDetails routePrefix={"/egypt-quest"}  {...this.props} {...this.state}></GameDetails>
            <ObavijestiCasino {...this.props}></ObavijestiCasino>
       </div>
    }
}